<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <b-container>
    <b-breadcrumb :items="bread" class="mt10"></b-breadcrumb>

    <b-card
      header="首席科学家预评估意见表"
      header-tag="header"
      align="center"
      header-class="login-header"
      class="form-background"
      style="text-align: left !important;"
    >
      <b-alert show>
        <span style="min-width:250px;display:inline-block">申请号：{{CSItem.applyNo}}</span>
        <span style="margin-left:20px">项目名称：{{CSItem.prjName}}</span>
        <br />
        <span>项目批准号：{{CSItem.prjNum}}</span>
        <br />
        <span style="min-width:250px;display:inline-block">航次编号：{{CSItem.cruiseNumber}}</span>
        <span style="margin-left:20px">航次名称：{{CSItem.cruiseName}}</span>
        <br />
        <span style="min-width:250px;display:inline-block">投标单位：{{CSItem.tenderUnit}}</span>
        <span style="margin-left:20px">航次首席：{{CSItem.tenderUnitChief}}</span>
        <br />
      </b-alert>

      <b-form @submit="submit">
        <b-spinner variant="primary" label="Spinning" v-if="loading"></b-spinner>
        <b-form-group
          v-for="(item,index) in items"
          :label="getQuestionLabel(item, index)"
          label-for="input-3"
          :key="item.id"
          :class="{ 'question-disabled': isItemDisabled(index) }"
        >
          <b-row v-if="item.answerType == 'Radio'">
            <b-badge class="badge-left" variant="secondary">{{item.prevText}}</b-badge>
            <b-form-radio-group
              :class="item.prevText ? '' : 'badge-left'"
              :options="item.value"
              :name="item.cruiseQuestIdName"
              v-model="form[index].value"
              @change="onOptionChange(index, $event)"
              :required="!isItemDisabled(index)"
              :disabled="isItemDisabled(index)"
            ></b-form-radio-group>
            <b-badge variant="success">{{item.postText}}</b-badge>
          </b-row>

          <b-row v-if="item.answerType == 'Checkbox'">
            <b-form-checkbox-group
              v-model="form[index].value"
              class="badge-left"
              id="checkbox-group-1"
              :options="getCheckboxOptions(item, index)"
              :name="item.cruiseQuestIdName"
              @change="onOptionChange(index, $event)"
              :disabled="isItemDisabled(index)"
            ></b-form-checkbox-group>
          </b-row>

          <b-row v-if="item.answerType == 'Text'">
            <b-form-textarea 
              id="textarea" 
              v-model="form[index].value" 
              rows="2" 
              class="badge-left" 
              @change="textChange"
              :required="!isItemDisabled(index)"
              :disabled="isItemDisabled(index)"
            ></b-form-textarea>
          </b-row>
        </b-form-group>

        <b-button
          v-if="code != '999'"
          fuid
          type="submit"
          variant="primary"
          :disabled="commiting"
          style="padding:15px 50px; background-color:#0582bb;border:1px solid #006ea7;"
        >
          <b-spinner v-if="commiting" small style="margin-right:20px"></b-spinner>
          {{ showOtherOptions ? '填写完成，提交' : '确认提交' }}
        </b-button>
      </b-form>
    </b-card>

    <link-component></link-component>
  </b-container>
</template>

<script>
import LinkComponent from '@/components/LinkComponent.vue';
import { axiosServer } from '@/api/judge';
import { urls } from '@/api/urls';

export default {
  components: { LinkComponent },
  name: 'option',
  props: {},
  computed: {},
  data() {
    return {
      items: [],

      bread: [
        {
          text: '首页',
          href: '/index'
        },
        {
          text: '提交首席科学家预评估意见表'
        }
      ],
      form: [],
      reqBody: { page: 1, pageSize: 100 },
      CSItem: {},
      loading: false,
      commiting: false,
      code: 0,
      showOtherOptions: false
    };
  },
  activated() {
    this.form = [];
    this.showOtherOptions = false; // 初始化时先禁用其他选项
    this.requestQuestionaire();
    this.code = this.$route.query.code;
    this.CSItem = {
      cruiseNumber: this.$route.query.cruiseNumber,
      cruiseName: this.$route.query.cruiseName,
      tenderUnit: this.$route.query.tenderUnit,
      tenderUnitChief: this.$route.query.tenderUnitChief,
      applyNo: this.$route.query.applyNo,
      tenderId: this.$route.query.tenderId,
      prjNum: this.$route.query.prjNum,
      prjName: this.$route.query.prjName
    };
  },

  deactivated() {},
  mounted() {
    let loginName = this.$cookies.get('username');
    if (!loginName) {
      //                this.$router.push({name: 'login', query: {tip: 1, msg: "访问搭载需求征集页面需要先登录"}})
    }
  },
  methods: {
    textChange() {},
    isCarryQuestionItem(item) {
      return item && item.question && (
        item.question.includes('是否搭载') ||
        item.question.includes('是否继续搭载')
      );
    },
    normalizeQuestionOrder(list) {
      const carryIndex = list.findIndex(item => this.isCarryQuestionItem(item));
      if (carryIndex <= 0) {
        return list;
      }

      const normalizedList = list.slice();
      const carryQuestion = normalizedList.splice(carryIndex, 1)[0];
      normalizedList.unshift(carryQuestion);
      return normalizedList;
    },
    isCarryQuestion() {
      return this.items.length > 0 && this.isCarryQuestionItem(this.items[0]);
    },
    getQuestionLabel(item, index) {
      if (index === 0 && item.question && item.question.includes('是否搭载')) {
        return item.question.replace('是否搭载', '是否继续搭载');
      }

      return item.question;
    },
    isItemDisabled(index) {
      if (index === 0 || !this.isCarryQuestion()) {
        return false;
      }

      return !this.showOtherOptions;
    },
    isContinueCarryValue(value) {
      return value && (
        value.toString().includes('继续') ||
        value.toString().includes('continue') ||
        value.toString().toLowerCase().includes('continue')
      );
    },
    getCommunicationQuestionIndex() {
      return this.items.findIndex(item => item.question && item.question.includes('主动沟通'));
    },
    getContactMethodQuestionIndex() {
      return this.items.findIndex(item => item.question && item.question.includes('采用了何种方式'));
    },
    isNoCommunicationValue(value) {
      return value && value.toString().includes('否');
    },
    isYesCommunicationValue(value) {
      return value && value.toString().includes('是');
    },
    getNoContactOptionValue(index) {
      const item = this.items[index];
      if (!item || !item.value) {
        return '';
      }

      const option = item.value.find(optionItem => optionItem.text && optionItem.text.includes('未主动联系'));
      return option ? option.value : '';
    },
    getOrderedCheckboxValue(item, checkedValue) {
      if (!item || !item.value || !Array.isArray(checkedValue)) {
        return checkedValue || [];
      }

      return item.value
        .map(option => option.value)
        .filter(value => checkedValue.includes(value));
    },
    getCheckboxOptions(item, index) {
      if (index !== this.getContactMethodQuestionIndex()) {
        return item.value;
      }

      const communicationIndex = this.getCommunicationQuestionIndex();
      if (communicationIndex < 0 || !this.form[communicationIndex]) {
        return item.value;
      }

      const communicationValue = this.form[communicationIndex].value;
      const shouldDisableNoContact = this.isYesCommunicationValue(communicationValue);
      const shouldDisableOtherOptions = this.isNoCommunicationValue(communicationValue);

      return item.value.map(option => ({
        ...option,
        disabled:
          option.text && option.text.includes('未主动联系') ? shouldDisableNoContact : shouldDisableOtherOptions
      }));
    },
    syncContactMethodByCommunication(nextCommunicationValue) {
      const communicationIndex = this.getCommunicationQuestionIndex();
      const contactMethodIndex = this.getContactMethodQuestionIndex();

      if (
        communicationIndex < 0 ||
        contactMethodIndex < 0 ||
        !this.form[communicationIndex] ||
        !this.form[contactMethodIndex]
      ) {
        return;
      }

      const communicationValue =
        nextCommunicationValue === undefined ? this.form[communicationIndex].value : nextCommunicationValue;
      const noContactValue = this.getNoContactOptionValue(contactMethodIndex);
      if (!noContactValue) {
        return;
      }

      if (this.isNoCommunicationValue(communicationValue)) {
        this.$set(this.form[contactMethodIndex], 'value', [noContactValue]);
      } else if (this.isYesCommunicationValue(communicationValue)) {
        this.$set(this.form[contactMethodIndex], 'value', this.form[contactMethodIndex].value.filter(
          value => value !== noContactValue
        ));
      }
    },
    onOptionChange(index, value) {
      const communicationIndex = this.getCommunicationQuestionIndex();
      const contactMethodIndex = this.getContactMethodQuestionIndex();

      if (index === communicationIndex) {
        this.$set(this.form[communicationIndex], 'value', value);
        this.syncContactMethodByCommunication(value);
        this.$forceUpdate();
      } else if (index === contactMethodIndex) {
        this.syncContactMethodByCommunication();
        this.$forceUpdate();
      }

      // 如果是选项1发生变化，并且首个问题是"是否搭载"
      if (index === 0 && this.isCarryQuestion()) {
        const option1Value = value === undefined ? this.form[0].value : value;
        this.$set(this.form[0], 'value', option1Value);
        
        this.showOtherOptions = this.isContinueCarryValue(option1Value);
        
        // 如果选择了放弃搭载，清空其他选项的值
        if (!this.showOtherOptions) {
          for (let i = 1; i < this.form.length; i++) {
            if (this.items[i] && this.items[i].answerType === 'Checkbox') {
              this.$set(this.form[i], 'value', []);
            } else {
              this.$set(this.form[i], 'value', '');
            }
          }
        }
      }
    },
    submit(evt) {
      evt.preventDefault();
      
      // 检查选项1是否有值
      if (!this.form[0] || !this.form[0].value) {
        this.showSubitError('请选择第一个选项');
        return;
      }
      
      // 准备提交的数据
      let submitData = [];
      
      this.items.forEach((item, index) => {
        item.cruiseQuestIdName = item.cruiseQuestId + '-id';
        
        // 放弃搭载时后续问卷项禁用，只提交第一题
        if (this.isItemDisabled(index)) {
          return;
        }
        
        if (item.answerType == 'Checkbox') {
          this.form[index].result = this.getOrderedCheckboxValue(item, this.form[index].value).toString();
        } else {
          this.form[index].result = this.form[index].value;
        }
        
        submitData.push(this.form[index]);
      });
      
      this.commiting = true;
      axiosServer({
        url: urls.SvpCsAssessmentAnswer + '/all',
        params: submitData,
        type: 'post'
      })
        .then(resp => {
          this.commiting = false;
          if (resp.data.code == 0) {
            this.$bvToast.toast('提交成功', {
              title: '提示',
              toaster: 'b-toaster-top-center',
              solid: true,
              appendToast: true,
              variant: 'success',
              autoHideDelay: '2000'
            });
            this.$nextTick(() => {
              this.$router.push({ name: 'ChiefScientistOpinion' });
            });
          } else {            
            this.showSubitError(resp.data.msg);
          }
        })
        .catch(err => {
          this.commiting = true;
          this.showSubitError(err);
        });
    },
    showSubitError(err) {
      this.$bvToast.toast('提交失败:' + err, {
        title: '提示',
        toaster: 'b-toaster-top-center',
        solid: true,
        appendToast: true,
        variant: 'danger',
        autoHideDelay: '3000'
      });
    },
    requestQuestionaire() {
      this.loading = true;
      axiosServer({
        url: urls.SvpCsAssessmentQuestion,
        params: this.reqBody
      })
        .then(resp => {
          this.loading = false;
          this.items = this.normalizeQuestionOrder(resp.data.page.list);
          this.items.forEach((item, index) => {
            if (item.answerOption) {
              item.valueNoFormat = item.answerOption.split(',');
              item.showValue = item.answerOption.split(',');

              item.value = [];
              let suffix = '';
              if (item.optionType == 'Number') {
                suffix = '分';
              }
              item.valueNoFormat.forEach(element => {
                item.value.push({ text: element + suffix, value: element });
              });
            }

            // if(item.optionType == "Number"){
            //   let arry1 = []
            //   item.showValue.forEach(valueItem => {
            //      arry1.push(valueItem + "分")
            //   })
            //   item.showValue = arry1
            // }

            this.$set(this.form, index, {
              tenderId: this.CSItem.tenderId,
              cruiseQuestId: item.cruiseQuestId,
              applyNo: this.CSItem.applyNo,
              value: item.answerType == 'Checkbox' ? [] : ''
            });
          });
          this.requestAnswers();
        })
        .catch(e => {
          this.loading = false;
        });
    },

    requestAnswers() {
      axiosServer({
        url: urls.SvpCsAssessmentAnswer,
        params: { page: 1, pageSize: 100, applyNo: this.$route.query.applyNo, tenderId: this.$route.query.tenderId }
      })
        .then(resp => {
          if (resp.data.code == 0) {
            if (resp.data.page.list) {
              let answerList = resp.data.page.list;
              for (let i = 0; i < this.items.length; i++) {
                for (let j = 0; j < answerList.length; j++) {
                  let question = this.items[i];
                  let answer = answerList[j];
                  if (question.cruiseQuestId == answer.cruiseQuestId) {
                    if (answer.result) {
                      if (question.answerType == 'Checkbox') {
                        this.$set(this.form[i], 'value', answer.result.split(','));
                      } else {
                        this.$set(this.form[i], 'value', answer.result);
                      }
                    }
                    break;
                  }
                }
              }
              
              // 检查选项1的值来决定其他选项是否可填写（仅当首个问题是"是否搭载"时）
              if (this.form.length > 0 && this.form[0].value && this.isCarryQuestion()) {
                this.showOtherOptions = this.isContinueCarryValue(this.form[0].value);
              } else {
                // 如果首个问题不是"是否搭载"，则显示所有选项
                this.showOtherOptions = !this.isCarryQuestion();
              }

              this.syncContactMethodByCommunication();
              
              this.$forceUpdate();
            }
          }
        })
        .catch(err => {});
    }
  }
};
</script>

<style scoped>
.ChiefScientistOpinionForm-margin {
  margin-top: 35px;
}

.badge-left {
  margin-left: 40px;
  margin-right: 15px;
}

.left-margin {
  margin-left: 40px;
}

.question-disabled {
  color: #8a8f98;
}

.question-disabled .badge {
  opacity: 0.55;
}

.question-disabled >>> .custom-control-label,
.question-disabled >>> .form-control,
.question-disabled >>> .custom-control-input:disabled ~ .custom-control-label {
  color: #8a8f98;
  cursor: not-allowed;
}

.proj-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 300px;
  padding: 0px;
  margin-bottom: 0px;
}

/* 响应式布局：方案不同屏幕尺寸分别使用不同的CSS样式 */
@media (max-width: 575.99px) {
  .form-style {
    text-align: left;
    width: 100%;
  }

  .botton-row {
    margin-bottom: 20px;
  }
}

@media (min-width: 576px) {
  .form-style {
    text-align: left;
    width: 100%;
  }

  .botton-row {
    margin-bottom: 20px;
  }
}

@media (min-width: 768px) {
  .form-style {
    text-align: left;
    width: 70%;
    margin: 0 auto;
  }

  .botton-row {
    margin-bottom: 20px;
    padding: 0 50px;
  }
}

@media (min-width: 992px) {
  .form-style {
    text-align: left;
    width: 70%;
    margin: 0 auto;
  }

  .botton-row {
    margin-bottom: 20px;
    padding: 0 100px;
  }
}

@media (min-width: 1200px) {
  .form-style {
    text-align: left;
    width: 70%;
    margin: 0 auto;
  }

  .botton-row {
    margin-bottom: 20px;
    padding: 0 200px;
  }
}
</style>
